module.exports = __webpack_public_path__ + "static/media/nn.afc51a05.png";